import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Search, X } from "lucide-react";

interface ActivityLogFiltersProps {
  filters: {
    user_id: string;
    action_category: string;
    action_type: string;
    search: string;
    start_date: string;
    end_date: string;
  };
  onFiltersChange: (filters: any) => void;
  onClear: () => void;
}

const categories = ["auth", "profile", "admin", "security", "data", "system"];

export const ActivityLogFilters = ({
  filters,
  onFiltersChange,
  onClear,
}: ActivityLogFiltersProps) => {
  const handleCategoryToggle = (category: string) => {
    onFiltersChange({
      ...filters,
      action_category: filters.action_category === category ? "" : category,
    });
  };

  return (
    <div className="space-y-4 mb-6 p-4 border rounded-lg bg-card">
      <div className="flex flex-wrap gap-2">
        {categories.map((category) => (
          <Badge
            key={category}
            variant={filters.action_category === category ? "default" : "outline"}
            className="cursor-pointer"
            onClick={() => handleCategoryToggle(category)}
          >
            {category}
          </Badge>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search descriptions..."
            value={filters.search}
            onChange={(e) =>
              onFiltersChange({ ...filters, search: e.target.value })
            }
            className="pl-9"
          />
        </div>

        <Input
          type="date"
          placeholder="Start date"
          value={filters.start_date}
          onChange={(e) =>
            onFiltersChange({ ...filters, start_date: e.target.value })
          }
        />

        <Input
          type="date"
          placeholder="End date"
          value={filters.end_date}
          onChange={(e) =>
            onFiltersChange({ ...filters, end_date: e.target.value })
          }
        />
      </div>

      {(filters.search ||
        filters.action_category ||
        filters.start_date ||
        filters.end_date) && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onClear}
          className="w-full"
        >
          <X className="h-4 w-4 mr-2" />
          Clear Filters
        </Button>
      )}
    </div>
  );
};
